import { LoaderFunctionArgs } from "react-router-dom";
import { HostSystemItemSortType } from "@tlc/ls2pac/dto/HostSystemItemSortType";
import { isHoldsSortType } from "../HostSystemItemSortControl";
import { getChildHoldsSortable } from "@tlc/ls2pac/components/services/Holds";
import axios from "axios";

export const childHoldsLoader = async ({
  request,
  params,
}: LoaderFunctionArgs) => {
  const id = params.id!;
  const url = new URL(request.url);
  const sortParam = url.searchParams.get("sort");
  const sort =
    sortParam && isHoldsSortType(sortParam)
      ? sortParam
      : HostSystemItemSortType.Status;
  const page = parseInt(url.searchParams.get("page") || "0", 10);
  const pageSize = parseInt(url.searchParams.get("size") || "10", 10);
  const dataPromise = getChildHoldsSortable(id, page, pageSize, sort, true)
    .then((holdsRes) => ({
      sort,
      page,
      pageSize,
      holds: holdsRes.holds,
      childHoldsTotalArrived: holdsRes.totalArrivedHolds,
      childHoldsTotalCount: holdsRes.totalHolds,
    }))
    .catch((error) => {
      console.error("Error fetching child holds", error);
      if (axios.isAxiosError(error) && error.response?.status === 403) {
        throw new Response("Forbidden", { status: 403 });
      }
      throw error;
    });

  return { data: dataPromise, pageSize: pageSize }; // need synchronous pageSize for skeletons array in React.Suspense fallback
};
